import type { DocumentTagsInputFragment } from "../client/generated";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { AccessTagInput } from "@acdc2/ui/components/access-tag-input";

type Props = Pick<
  ComponentProps<typeof AccessTagInput>,
  "onTagAdd" | "onTagRemove"
> & {
  fragment: DocumentTagsInputFragment;
};

export function DocumentTagsInput({ fragment, onTagAdd, onTagRemove }: Props) {
  const { t } = useTranslation();

  return (
    <AccessTagInput
      tags={fragment.tags}
      placeholder={t("DocumentTagsInput.placeholder")}
      onTagAdd={onTagAdd}
      onTagRemove={onTagRemove}
    />
  );
}
